import { cn } from '@commenda/utils';
import React from 'react';

import { IconButton } from '../../IconButton';
import { Icons } from '../../Icons';
import { DATA_GRID_CELL_MASK_LENGTH } from '../constants';

export interface DataGridCellHiddenRevealConfig {
  isRevealed: boolean;
  onToggle: () => void;
  ariaLabelReveal: string;
  ariaLabelHide: string;
}

export interface DataGridCellHiddenProps {
  children: React.ReactNode;
  revealConfig?: DataGridCellHiddenRevealConfig;
  maskLength?: number;
  className?: string;
}

const DataGridCellHidden = ({
  children,
  revealConfig,
  maskLength = DATA_GRID_CELL_MASK_LENGTH,
  className,
}: DataGridCellHiddenProps) => {
  const isRevealed = revealConfig?.isRevealed ?? false;

  return (
    <div className={cn('flex w-full items-center gap-md', className)}>
      <span className="txt-small-regular min-w-0 flex-1 truncate text-text-primary">
        {isRevealed ? children : '•'.repeat(maskLength)}
      </span>
      {revealConfig ? (
        <IconButton
          size="sm"
          variant="default"
          onClick={revealConfig.onToggle}
          aria-label={
            isRevealed
              ? revealConfig.ariaLabelHide
              : revealConfig.ariaLabelReveal
          }
          aria-pressed={isRevealed}
          icon={
            isRevealed ? (
              <Icons.Eye className="size-4" />
            ) : (
              <Icons.EyeOff className="size-4" />
            )
          }
        />
      ) : null}
    </div>
  );
};

export { DataGridCellHidden };
